export default __webpack_public_path__ + "static/media/feather_alert-circle.c1f69c01.svg";